export enum ControlTypes {
  Text = "text",
  Number = "number",
  Date = "date",
  DateTime = "datetime",
  Time = "time",
  CheckBox = "checkbox",
  Select = "select",
  Title = "title",
  Empty="empty",
  Lookup = "lookup",
  TextArea = "textarea",
  Color = "color",
  LogText = "logText",
  LogImage = "LogImage",
  Password = "password",
  ProgressBar='progressbar',
  Template="template",
  Image="Image",
  HyperLink="HyperLink"
}
